import React from 'react'
import { Typography, Link } from '@mui/material'
import { FooterNavigationLinks } from '../../../../../GlobalVariables/Navigation'

const ZutoTerms: React.FC = () => {
  return (
    <Typography sx={{ mt: 7 }} variant="bodySmall" component="p">
      You agree to Zuto&apos;s{' '}
      <Link
        href={FooterNavigationLinks.termsAndConditions}
        color="primary.main"
        underline="hover"
      >
        Terms &amp; Conditions
      </Link>{' '}
      and{' '}
      <Link
        href={FooterNavigationLinks.privacyPolicy}
        color="primary.main"
        underline="hover"
      >
        Privacy Policy
      </Link>
      .
    </Typography>
  )
}

export default ZutoTerms
